import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'

interface SetEmailBodyArgs extends MessageArgs {
  body: string
  emailGuid: string
  trackingPixel?: string
  rewriteRequired?: boolean
}

export default async function setEmailBodyHandler(data: SetEmailBodyArgs) {
  const args: CallbackArgs = defaultCallbackArgs()

  try {
    if (data.rewriteRequired) {
      await office.body.set(data.body)
    }

    const trackingPixel = data.trackingPixel ? `<img src="${data.trackingPixel}" class="ci-tracking-pixel" width="1" height="1" />` : null

    await injectTrackingPixel(trackingPixel)

    await office.customProps.setTrackingId(data.emailGuid)
  } catch (error) {
    args.errorCode = 500
    args.errorMessage = error?.message || 'Failed to set email body'
  } finally {
    sendMessageToSidebar('SetEmailBodyCallback', args)
  }
}

async function injectTrackingPixel(trackingPixel: string | null) {
  if (office.body.appendOnSendSupported()) {
    try {
      await office.body.appendOnSend(trackingPixel)
      return
    } catch {
      // What can actually reach here is a runtime failure — the 10s timeout in
      // officeApiCallAsync, or a transient Office.js error — since the probe above
      // already covers the requirement set and the method. Catching broadly is still
      // deliberate: the probe and that gate disagreeing is the very defect this fixes,
      // so any future drift degrades to the fallback instead of failing silently.
    }
  }

  await office.body.prepend(trackingPixel)
  await office.save()
}
